import React, { Fragment } from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "bootstrap/dist/js/bootstrap.bundle.min";
import "bootstrap/dist/css/bootstrap.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer } from "react-toastify";

import reportWebVitals from "./reportWebVitals";
import store from "./redux/store";
import DefaultRoutes from "./routes/routes";

import "./index.css";
import "./style.scss";

import { BrowserRouter } from "react-router-dom";
import CasinoCrashGame from "./page/game/crash-casino";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
 
  // <Fragment>
 <React.StrictMode>
     <ToastContainer autoClose={1500} />
    <Provider store={store}>
      {/* <BrowserRouter> */}
      <DefaultRoutes />
        {/* <CasinoCrashGame /> */}
      {/* </BrowserRouter> */}

     
     
    </Provider>
     </React.StrictMode>
  // </Fragment>
    
   
 
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
